import PropTypes from 'prop-types'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react'
import { Link } from 'react-router-dom'

export const UiBreadcrumb = ({ items = [] }) => {
  return (
    <Breadcrumb fontWeight='medium' fontSize='sm'>
      <BreadcrumbItem>
        <BreadcrumbLink as={Link} to='/dashboard'>Home</BreadcrumbLink>
      </BreadcrumbItem>
      {items.map(item => (
        <BreadcrumbItem key={item.label} isCurrentPage={!!item.isCurrentPage}>
          {item.isCurrentPage ? (
            <BreadcrumbLink href="">{item.label}</BreadcrumbLink>
          ) : (
            <BreadcrumbLink as={Link} to={item.path}>{item.label}</BreadcrumbLink>
          )}
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  )
}

UiBreadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string,
      isCurrentPage: PropTypes.bool
    })
  )
}
